import React, { Component, Fragment } from 'react';
import { Col, Row, Button } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import AlertModal from '../../../shared/components/Modal';

class MedicalPlanTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            idMedicalPlanTemplate: null,
            analisis: null,
            medicalPlan: null,
            recomendations: null
        };
    }

    componentDidMount = () => {
        this.getMedicalPlanTemplate();
    }

    createMedicalPlanTemplate = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pantillas-analisis-plan-medico/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                analisis: this.state.analisis,
                plan_medico: this.state.medicalPlan,
                recomendaciones: this.state.recomendations
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            this.setState({
                idMedicalPlanTemplate: data.plan_medico_plantilla.id_plan_medico_plantilla,
                analisis: data.plan_medico_plantilla.analisis,
                plan_medico: data.plan_medico_plantilla.plan_medico,
                recomendaciones: data.plan_medico_plantilla.recomendaciones,
                colorAlertModal: "success",
                messageAlertModal: "Plantilla de Analisis y Plan Medico Guardada exitosamente",
                showAlertModal: true
            });
        }).catch((error) => {
            console.log(error);
            this.setState({
                colorAlertModal: "danger",
                messageAlertModal: "Ha ocurrido un error en el servidor",
                showAlertModal: true
            });
        });
    }

    getMedicalPlanTemplate = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pantillas-analisis-plan-medico/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            
            console.log("stateData",data[0]);
            this.setState({
                idMedicalPlanTemplate: data[0].id_plan_medico_plantilla,
                analisis: data[0].analisis,
                medicalPlan: data[0].plan_medico,
                recomendations: data[0].recomendaciones
            }, () => {
            });
        }).catch((error) => {
            console.log("Plan Medico error:", error);
        });
    }

    updateMedicalPlanTemplate = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pantillas-analisis-plan-medico/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_plan_medico_plantilla: this.state.idMedicalPlanTemplate,
                analisis: this.state.analisis,
                plan_medico: this.state.medicalPlan,
                recomendaciones: this.state.recomendations
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            this.setState({
                idMedicalPlanTemplate: data.plan_medico_plantilla.id_plan_medico_plantilla,
                analisis: data.plan_medico_plantilla.analisis,
                plan_medico: data.plan_medico_plantilla.plan_medico,
                recomendaciones: data.plan_medico_plantilla.recomendaciones,
                colorAlertModal: "success",
                messageAlertModal: "Plantilla de Analisis y Plan Medico Actualizada exitosamente",
                showAlertModal: true
            });
        }).catch((error) => {
            console.log(error);
            this.setState({
                colorAlertModal: "danger",
                messageAlertModal: "Ha ocurrido un error en el servidor",
                showAlertModal: true
            });
        });
    }

    onOkModal = () => {
        this.setState({
            messageAlertModal: "",
            colorAlertModal: "",
            showAlertModal: false
        });
    }

    onToggleModal = () => {
        this.setState({
            messageAlertModal: "",
            colorAlertModal: "",
            showAlertModal: false
        });
    }

    render() {
        return (<Fragment>
            <div className="card__title">
                <h5 className="bold-text">Analisis y Plan Medico</h5>
            </div>
            
            <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
                <div className="form" style={{ width: '100%' }}>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Analisis</span>
                        <div className="form__form-group-field">
                            <textarea
                                style={{ width: '100%' }}
                                value={this.state.analisis}
                                onChange={(event) => {
                                    this.setState({ analisis: event.target.value });
                                }}
                                required={true}>
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
                <div className="form" style={{ width: '100%' }}>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Plan Médico</span>
                        <div className="form__form-group-field">
                            <textarea
                                style={{ width: '100%' }}
                                value={this.state.medicalPlan}
                                onChange={(event) => {
                                    this.setState({ medicalPlan: event.target.value });
                                }}
                                required={true}>
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ flex: 1, flexDirection: 'row', display: 'flex' }}>
                <div className="form" style={{ width: '100%' }}>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Recomendaciones</span>
                        <div className="form__form-group-field">
                            <textarea
                                style={{ width: '100%' }}
                                value={this.state.recomendations}
                                onChange={(event) => {
                                    this.setState({ recomendations: event.target.value });
                                }}
                                required={true}>
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>

            <Button
                color="primary"
                onClick={() => {
                    if (this.state.idMedicalPlanTemplate == null) {
                        this.createMedicalPlanTemplate();
                    }
                    else {
                        this.updateMedicalPlanTemplate();
                    }
                }}
            >
                Guardar
            </Button>

            <AlertModal
                color={this.state.colorAlertModal}
                title={this.state.messageAlertModal}
                modal={this.state.showAlertModal}
                onOk={() => this.onOkModal()}
                toggle={() => this.onToggleModal()}
            />


        </Fragment>);
    }
}

export default MedicalPlanTemplate;